/**
 * External dependencies
 */
import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";
export default class SuccessStories {
	constructor(block) {
		this.block = block;
		this.grid = this.block.querySelector(".stories-grid");

		if (this.grid) {
			this.grid.style.opacity = 0;
			window.addEventListener("DOMContentLoaded", this.init.bind(this));
		}
	}

	init() {
		const firstItem = this.grid.querySelector(".grid-item");

		if (!firstItem) {
			return;
		}

		const spacer = document.createElement("div");
		spacer.className = "masonry-item grid-spacer";

		this.grid.insertBefore(spacer, firstItem.nextSibling);

		const masonry = new Masonry(this.grid, {
			columnWidth: ".grid-sizer",
			itemSelector: ".masonry-item",
			percentPosition: true,
			gutter: 30,
			transitionDuration: 0,
		});

		imagesLoaded(this.grid).on("done", () => {
			masonry.layout();
			this.grid.style.opacity = 1;
		});
	}
}
